import {createFileRoute, redirect, useRouterState} from '@tanstack/react-router'
import {isAuthenticated} from "../../utils/auth.ts";
import Layout, {NoItems} from "../../components/Layouts/Layout.tsx";
import {useContext, useEffect} from "react";
import {PatientsContext} from "../../context/PatientsContext.tsx";
import {OrganizationContext} from "../../context/OrganizationContext.tsx";
import PatientSidebarItem from "../../components/Patients/PatientSidebarItem.tsx";
import {capitalize} from "../../utils/strings.ts";
import {useTranslation} from "react-i18next";

export const Route = createFileRoute('/patients/')({
  beforeLoad: async () => {
    if(!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: PatientsIndex,
})

function PatientsIndex() {
  
  const router = useRouterState();
  const { setActivePatient, patients, openAddPatientModal } = useContext(PatientsContext);
  const { hasEmrIntegration } = useContext(OrganizationContext);
  const { t } = useTranslation('translation', {keyPrefix: 'layout.sidebar'});
  
  useEffect(() => {
    setActivePatient(null);
  }, []);
  
  return (
    <Layout>
      <div className={'bg-white xs:hidden w-0 block w-screen h-full px-4 pt-6 relative'}>
        <h3 className={'text-2xl font-bold mb-2'}>{capitalize(t('patients'))}</h3>
        {!hasEmrIntegration() && (
          <button type={'button'} className={'absolute top-8 right-6 cursor-pointer hover:opacity-80'}
                  onClick={openAddPatientModal}>
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="20" height="20"
                 viewBox="0 0 24 24">
              <path fill="#363B43" transform="translate(2 2)"
                    d="M10 0C10.552285 0 11 0.44771525 11 1L11 8.9989996L19 9C19.552284 9 20 9.4477148 20 10C20 10.552285 19.552284 11 19 11L11 10.999L11 19C11 19.552284 10.552285 20 10 20C9.4477148 20 9 19.552284 9 19L9 10.999L1 11C0.44771525 11 0 10.552285 0 10C0 9.4477148 0.44771525 9 1 9L9 8.9989996L9 1C9 0.44771525 9.4477148 0 10 0Z"
                    fillRule="evenodd"/>
            </svg>
          </button>
        )}
        {!!patients && patients.length > 0 &&
          <p className={'text-neutral-500 text-sm'}>
            {`${patients.length} ${patients.length === 1 ? t('patient') : t('patients')}`}
          </p>
        }
        {!patients || patients.length === 0 && <NoItems/>}
        {!!patients && patients.length > 0 &&
          <ul
            className={'h-[calc(100%-7rem)] w-full overflow-auto flex flex-col items-start justify-start gap-1 mt-3 pt-3 scroller--blurred-container'}>
            {patients.map(patient => <PatientSidebarItem key={patient.id} patient={patient}
                                                         active={router.location.pathname.includes(`/patients/${patient.id}`)}/>)}
          </ul>
        }
      </div>
    </Layout>
  )
}
